
const Home = {
    text: 'Home',
    link: '/home',
    icon: 'icon-home'
};

const ManageUsers = {
    text: 'Manage Users',
    link: '/manage-admin-users',
    icon: 'icon-user'
};
const EvictionData = {
    text: 'Eviction Data',
    link: '/eviction-data',
    icon: 'fa fas fa-database'
};
const ReportManagementSection = {
    text: 'Report Management',
    link: '/report-management',
    icon: 'fa icon-docs'

};

const ManagePayment = {
    text: 'Manage Payment',
    link: '/manage-payment',
    icon: 'icon-wallet'
};

const PricingSettings = {
    text: 'Pricing Settings',
    link: '/pricing-settings',
    icon: 'icon-user'
};

const AlertsAnnouncemnet = {
    text: 'Alerts & Announcements',
    link: '/alert-announcements',
    icon: 'icon-bell'
};
const ReportView = {
    text: 'Review Reports',
    link: '/reports-view',
    icon: 'far fa-file-alt'
};
const PlatformReport = {
    text: 'Platform Report',
    link: '/platform-report',
    icon: 'icon-graph'
};
const global = {
    text: 'Global Search',
    link: '/global-search',
    icon: 'icon-eye'

};
const inspectionForm = {
    text: 'Inspection Form',
    link: '/inspectionFrom',
    icon: 'far fa-file-alt'
};
const disclosureManagment = {
    text: 'Disclosure Management',
    link: 'disclosureManagment',
    icon: 'icon-settings'
};

const logs = {
    text: 'Logs',
    link: 'logs',
    icon: 'far fa-file-alt'
};

const ConsumerDisclosure = {
    text: 'Consumer Disclosure',
    link: '/consumer-disclosure',
    icon: 'icon-settings',
    submenu: [
        {
            text: 'Request Report',
            link: '/consumer-disclosure/request-report'
        },
        {
            text: 'Request Grievance',
            link: '/consumer-disclosure/request-grievance'
        },
    ]
};

const Subscriber = {
    text: 'Subscribers',
    link: '/subscribers',

    icon: 'fa fas fa-users',
    submenu: [
        {
            text: 'New Signup Request',
            link: '/subscribers/new-request'
        },
        {
            text: 'Manage Subscriber',
            link: '/subscribers/manage-subscriber'
        },

        {
            text: 'Manage Properties',
            link: '/subscribers/manage-properties'
        },
        {
            text: 'Archived Signup',
            link: '/subscribers/archived-request'
        },
        {
            text: 'Inspection Form',
            link: '/inspectionFrom'
        }

    ]
};

const Marketing = {
    text: 'Marketing',
    link: '/marketing',

    icon: 'fa fas fa-users',
    submenu: [
        {
            text: 'Marketing Queue',
            link: '/marketing/marketing-queue'
        },
        {
            text: 'Report',
            link: '/marketing/reportList'
        },

        {
            text: 'DND List',
            link: '/marketing/dndList'
        },

    ]
};

// const VendorOrders = {
//     text: 'Vendor Orders',
//     link: '/vendor-orders/queue',
//     icon: 'fa fas fa-clipboard-list'
// };

const ApiMonitor = {
    text: 'API Monitor',
    link: '/api-monitor',
    icon: 'fa fas fa-heartbeat'
};

const Settings = {
    text: 'Settings',
    link: '/admin-settings',
    icon: 'icon-settings',
    submenu: [
        {
            text: 'Offer Codes',
            link: '/admin-settings/offer-codes'
        },
        {
            text: 'Product Combos',
            link: '/admin-settings/combos'
        },
        {
            text: 'Email Settings',
            link: '/admin-settings/email-settings'
        },
        {
            text: 'Adverse Letters',
            link: '/admin-settings/adverseLetters'
        },
        {
            text: 'PredictScreen Criteria',
            link: '/admin-settings/screening'
        },
        {
            text: 'Pricing',
            link: '/admin-settings/pricing'
        },
        // {
        //     text:'Edit Subscriber Setup ',
        //     link:'/admin-settings/editSubscriber'
        // },
        {
            text: 'Acknowledgement Message',
            link: '/document-compliance',
            // icon: 'icon-eye'

        },
        {
            text: 'Processing Rules',
            link: '/admin-settings/processing-rule'
        },
        {
            text: 'Data Management',
            link: '/admin-settings/data-managment'
        },
        {
            text: 'Website Management',
            link: '/admin-settings/website-managment'
        },
        {
            text: 'Tax Management',
            link: '/admin-settings/tax-managment'
        },
        {
            text: 'Vendor Settings',
            link: '/admin-settings/vendor-settings'
        }

    ]
};

const Payment = {
    text: 'Manage Payment',
    link: '/manage-payments',
    icon: 'icon-settings',
    submenu: [
        {
            text: 'Manage Invoice ',
            link: '/manage-payments/invoice'
        },
        // {
        //     text: 'Send  Invoice',
        //     link: '/manage-payments/sendInvoice'
        // },
        {
            text: 'DV  Invoice',
            link: '/manage-payments/dvInvoice'
        },
        {
            text: 'Manage Wallet',
            link: '/manage-payments/manageWallet'
        },
        {
            text: 'Manage Credit Limit',
            link: '/manage-payments/credit'
        },
        {
            text: 'Waive-Off Transactions',
            link: '/manage-payments/waiveOffTransactions'
        },
        {
            text: 'Tax Summary Report',
            link: '/manage-payments/taxSummaryReport'
        }
    ]
};

const DocumentCompliance = {
    text: 'Acknowledgement Message',
    link: '/document-compliance',
    icon: 'icon-eye'

};

const ManageAlias = {
    text: 'Manage Alias List',
    link: '/manage-alias-setting',
    icon: 'fa fas fa-list',
    submenu: [
        {
            text: 'Eviction Disposition',
            link: '/manage-alias-setting/evictionData'
        },
        {
            text: 'Debt Catagories',
            link: '/manage-alias-setting/collections'
        },
        {
            text: 'Criminal Disposition',
            link: '/manage-alias-setting/criminal'
        },
    ]
};

const ManageRolesAndPermissions = {
    text: 'Manage Roles & Permissions',
    link: '/adminManageRolesAndPermissions',
    icon: 'icon-user'
};
// const ManageRolesAndPermissions = {
//     text: 'Manage Roles & Permissions',
//     link: '/manageRolesAndPermissions',
//     icon: 'icon-user'
const activeReport = {
    text: 'Active Report',
    link: '/activeReport',
    icon: 'icon-user'
};
const inactiveReport = {
    text: 'Inactive Report',
    link: '/inactiveReport',
    icon: 'icon-user'
};
const qa = {
    text: 'Quality Assurance',
    icon: 'icon-user',
    submenu: [
        {
            text: 'QA Queue',
            link: '/qa'
        },
        {
            text: 'Errored Reports',
            link: '/qa/errors'
        },
        {
            text: 'Completed Reports',
            link: '/qa/completed'
        },
        {
            text: 'Vendor Orders',
            link: '/vendor-orders/queue'        
        },
    ]
};
// const representativeList = {
//     text: 'Sales Representative',
//     link: '/representativeList',
//     icon: 'icon-user'
const tenantFeedback = {
    text: 'Tenant Feedback',
    link: '/tenantFeedback',
    icon: 'fas fa-comments'
};
const Dashboard = {
    text: 'Dashboard',
    link: '/dashboard',
    icon: 'icon-speedometer',
    submenu: [
        {
            text: 'Dashbord v1',
            link: '/dashboard/v1'
        },
        {
            text: 'Dashbord v2',
            link: '/dashboard/v2'
        },
        {
            text: 'Dashbord v3',
            link: '/dashboard/v3'
        }
    ]
};

const Users = {
    text: 'Users',
    link: '/users',
    icon: 'icon-user',
    submenu: [
        {
            text: 'Manage Users',
            link: '/users/manageusers'
        },
        {
            text: 'Manage Roles & Permissions',
            link: '/users/manageRolesAndPermissions'
        },
        {
            text: 'Sales Representative List',
            link: '/users/salesrepresentative'
        }
    ]
};

const Properties = {
    text: 'Properties',
    link: '/manageProperties',
    icon: 'icon-grid'
};

const Widgets = {
    text: 'Widgets',
    link: '/widgets',
    icon: 'icon-grid'
};
const DVIntegration = {
    text: 'DV Integration',
    link: '/dv-integration',

    icon: 'fa fas fa-users',
    submenu: [
        {
            text: 'Subscriber',
            link: '/dv-integration/dv-subscriber'
        },
        {
            text: 'Properties',
            link: '/dv-integration/dv-properties'
        },

        {
            text: 'User',
            link: '/dv-integration/dv-users'
        },

    ]
};

const Elements = {
    text: 'Elements',
    link: '/elements',
    icon: 'icon-chemistry',
    submenu: [
        {
            text: 'Buttons',
            link: '/elements/buttons'
        },
        {
            text: 'Interaction',
            link: '/elements/interaction'
        },
        {
            text: 'Notification',
            link: '/elements/notification'
        },
        {
            text: 'SweetAlert',
            link: '/elements/sweetalert'
        },
        {
            text: 'Spinners',
            link: '/elements/spinners'
        },
        {
            text: 'Dropdown',
            link: '/elements/dropdown'
        },
        {
            text: 'Nav Tree',
            link: '/elements/navtree'
        },
        {
            text: 'Sortable',
            link: '/elements/sortable'
        },
        {
            text: 'Grid',
            link: '/elements/grid'
        },
        {
            text: 'Grid Masonry',
            link: '/elements/gridmasonry'
        },
        {
            text: 'Typography',
            link: '/elements/typography'
        },
        {
            text: 'Font Icons',
            link: '/elements/iconsfont'
        },
        {
            text: 'Weahter Icons',
            link: '/elements/iconsweather'
        },
        {
            text: 'Colors',
            link: '/elements/colors'
        },
        {
            text: 'Infinite Scroll',
            link: '/elements/infinitescroll'
        }
    ]
};

const Forms = {
    text: 'Forms',
    link: '/forms',
    icon: 'icon-note',
    submenu: [
        {
            text: 'Standard',
            link: '/forms/standard'
        },
        {
            text: 'Extended',
            link: '/forms/extended'
        },
        {
            text: 'Validation',
            link: '/forms/validation'
        },
        {
            text: 'Upload',
            link: '/forms/upload'
        },
        {
            text: 'Image Crop',
            link: '/forms/cropper'
        }
    ]
};

const Charts = {
    text: 'Charts',
    link: '/charts',
    icon: 'icon-graph',
    submenu: [
        {
            text: 'Flot',
            link: '/charts/flot'
        },
        {
            text: 'Radial',
            link: '/charts/radial'
        },
        {
            text: 'ChartJS',
            link: '/charts/chartjs'
        }
    ]
};

const Tables = {
    text: 'Tables',
    link: '/tables',
    icon: 'icon-grid',
    submenu: [
        {
            text: 'Standard',
            link: '/tables/standard'
        },
        {
            text: 'Extended',
            link: '/tables/extended'
        },
        {
            text: 'Angular Grid',
            link: '/tables/aggrid'
        },
        {
            text: 'NGxDatatables',
            link: '/tables/ngxdatatable'
        }
    ]
};

const Maps = {
    text: 'Maps',
    link: '/maps',
    icon: 'icon-map',
    submenu: [
        {
            text: 'Google',
            link: '/maps/google'
        },
        {
            text: 'Vector',
            link: '/maps/vector'
        }
    ]
};

const Pages = {
    text: 'Pages',
    link: '/pages',
    icon: 'icon-doc',
    submenu: [
        {
            text: 'Login',
            link: '/login'
        },
        {
            text: 'Register',
            link: '/register'
        },
        {
            text: 'Recover',
            link: '/recover'
        },
        {
            text: 'view_reprt',
            link: '/view_report'
        },
        {
            text: 'Signup',
            link: '/signup'
        },
        {
            text: 'Lock',
            link: '/lock'
        },
        {
            text: '404',
            link: '/404'
        },
        {
            text: '500',
            link: '/500'
        },
        {
            text: 'Maintenance',
            link: '/maintenance'
        }
    ]
};

const Blog = {
    text: 'Blog',
    link: '/blog',
    icon: 'icon-notebook',
    submenu: [
        {
            text: 'List',
            link: '/blog/list'
        },
        {
            text: 'Post',
            link: '/blog/post'
        },
        {
            text: 'Articles',
            link: '/blog/articles'
        },
        {
            text: 'Article View',
            link: '/blog/articleview'
        }
    ]
};

const Ecommerce = {
    text: 'Ecommerce',
    link: '/ecommerce',
    icon: 'icon-basket-loaded',
    submenu: [
        {
            text: 'Orders',
            link: '/ecommerce/orders'
        },
        {
            text: 'Order View',
            link: '/ecommerce/orderview'
        },
        {
            text: 'Products',
            link: '/ecommerce/products'
        },
        {
            text: 'Product View',
            link: '/ecommerce/productview'
        },
        {
            text: 'Checkout',
            link: '/ecommerce/checkout'
        }
    ]
};

const Extras = {
    text: 'Extras',
    link: '/extras',
    icon: 'icon-cup',
    submenu: [
        {
            text: 'Contacts',
            link: '/extras/contacts'
        },
        {
            text: 'Contact details',
            link: '/extras/contactdetails'
        },
        {
            text: 'Projects',
            link: '/extras/projects'
        },
        {
            text: 'Projects details',
            link: '/extras/projectsdetails'
        },
        {
            text: 'Team Viewer',
            link: '/extras/teamviewer'
        },
        {
            text: 'Social Board',
            link: '/extras/socialboard'
        },
        {
            text: 'Vote links',
            link: '/extras/votelinks'
        },
        {
            text: 'Bug tracker',
            link: '/extras/bugtracker'
        },
        {
            text: 'Faq',
            link: '/extras/faq'
        },
        {
            text: 'Help center',
            link: '/extras/helpcenter'
        },
        {
            text: 'Followers',
            link: '/extras/followers'
        },
        {
            text: 'Settings',
            link: '/extras/settings'
        },
        {
            text: 'Plans',
            link: '/extras/plans'
        },
        {
            text: 'File manager',
            link: '/extras/filemanager'
        },
        {
            text: 'Forum',
            link: '/extras/forum'
        },
        {
            text: 'Mailbox',
            link: '/extras/mailbox'
        },
        {
            text: 'Timeline',
            link: '/extras/timeline'
        },
        {
            text: 'Calendar',
            link: '/extras/calendar'
        },
        {
            text: 'Invoice',
            link: '/extras/invoice'
        },
        {
            text: 'Search',
            link: '/extras/search'
        },
        {
            text: 'Todo list',
            link: '/extras/todolist'
        },
        {
            text: 'Profile',
            link: '/extras/profile'
        },
        {
            text: 'Code editor',
            link: '/extras/codeeditor'
        }
    ]
};

const headingMain = {
    text: 'Main Navigation',
    heading: true
};

const headingComponents = {
    text: 'Components',
    heading: true
};

const headingMore = {
    text: 'More',
    heading: true
};

const subscriberSettings = {
    text: 'Subscriber Settings',
    link: '/subscriber-settings',
    icon: 'icon-settings',
    submenu: [
        {
            text: 'Email Settings',
            link: '/subscriber-settings/email-settings'
        }
    ]
};

const subscriberTenantManagement = {
    text: 'Tenant Management',
    link: '/tenant-management',
    icon: 'icon-settings'
};

export const menu = [
    headingMain,
    Home,
    PlatformReport,
    global,
    Settings,
    Users,

    Subscriber,
    AlertsAnnouncemnet,
    qa,
    // VendorOrders,
    ApiMonitor,
    EvictionData,
    ManageAlias,
    disclosureManagment,
    logs,
    ReportManagementSection,
    DVIntegration,
    // DocumentCompliance,
    tenantFeedback,
    // inspectionForm,
    Payment,

    // ReportView,
    // ManagePayment,
    // ConsumerDisclosure,
    // done by ashwini down
    //    activeReport,
    // inactiveReport,
    // representativeList,

    //    subscriberSettings,
    // subscriberSettings,
    Marketing,
    //    subscriberTenantManagement,
    // ManageUsers,
    // headingComponents,
    // Elements,
    // Forms,
    // Charts,
    // Tables,
    // Maps,
    // headingMore,
    //  Pages,
    // Blog,
    // Ecommerce,
    // Extras
    // Widgets

];
